import Hls from "hls.js";

/**
 * Whether HLS playback for this element should use the browser's native
 * pipeline (video.src = *.m3u8) instead of hls.js/MSE.
 *
 * Since Chromium ~150, canPlayType("application/vnd.apple.mpegurl") returns
 * "maybe" in every Chromium-family browser (Chrome shipped built-in HLS), so
 * a bare canPlayType check silently routes all of them onto that brand-new
 * native pipeline — which blanks or errors (MEDIA_ERR_SRC_NOT_SUPPORTED) in
 * derivatives like Dia and misrenders for some Chrome users (LADD-4312/4313).
 * Only WebKit's native player has a track record, so native is reserved for
 * Apple browsers (navigator.vendor covers Safari and every iOS browser
 * shell) and for browsers where MSE isn't available at all.
 */
export const preferNativeHls = (video: HTMLVideoElement): boolean => {
  if (!video.canPlayType("application/vnd.apple.mpegurl")) return false;
  const isWebkit =
    typeof navigator !== "undefined" &&
    navigator.vendor === "Apple Computer, Inc.";
  return isWebkit || !Hls.isSupported();
};
